import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-fh-image',
  templateUrl: './fh-image.component.html',
  styleUrls: ['./fh-image.component.scss']
})
export class FhImageComponent {
  @Input() src = '';
  @Input() class = '';
  @Input() alt = '';
  @Input() width: string | undefined;
  @Input() height: string | undefined;
}
